<template>
  <div class="highlights_wrapper">
    <h1>{{ highlightsData.title }}</h1>
    <div class="highlights_content content_wrapper">
      <div class="highlights_item" v-for="(item, index) in highlightsData.items" :key="item.id">
        <h4>{{ item.title }}</h4>
        <p class="intro">{{ item.intro }}</p>
        <div class="bottom_wrapper">
          <p class="line" :style="`background-color: ${item.color}`"></p>
          <!-- <div class="img-wrapper"> -->
          <img :src="item.imgSrc" :alt="item.id" />
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    highlightsData: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.highlights_wrapper {
  width: 100%;
  background: #f6f7f8;
  padding: 70px 0px;
  h1 {
    margin: 0;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
    margin-bottom: 70px;
  }
  .highlights_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .highlights_item {
      box-sizing: border-box;
      width: 28%;
      height: 300px;
      background: #ffffff;
      border-radius: 15px;
      padding: 25px;
      h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
      }
      .intro {
        font-size: 14px;
        font-weight: 300;
        color: #7f7f7f;
        margin-top: 16px;
        margin-bottom: 16px;
        line-height: 20px;
      }
      .bottom_wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        // align-items: start;
        .line {
          margin-top: 30px;
          width: 20px;
          height: 2px;
          // background: #4173fb;
        }
        img {
          max-width: 150px;
        }
      }
      &:hover {
        transform: scale(1.05);
        transition: scale 0.25s ease-in-out;
      }
    }
  }
}
</style>